var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 37.5C29.1053 37.5 37.5 29.1053 37.5 18.75C37.5 8.39466 29.1053 0 18.75 0C8.39466 0 0 8.39466 0 18.75C0 29.1053 8.39466 37.5 18.75 37.5ZM27.8517 13.1402C28.2053 12.7159 28.148 12.0853 27.7237 11.7318C27.2994 11.3782 26.6688 11.4355 26.3153 11.8598L17.3007 22.6774C16.9539 23.0934 16.759 23.3238 16.6034 23.4653L16.5975 23.4707L16.591 23.4659C16.4233 23.339 16.2083 23.1272 15.8253 22.7443L11.1239 18.0429C10.7334 17.6524 10.1002 17.6524 9.70972 18.0429C9.3192 18.4334 9.3192 19.0666 9.70972 19.4571L14.4111 24.1585L14.452 24.1993C14.7784 24.526 15.0925 24.8402 15.3848 25.0611C15.7121 25.3087 16.1409 25.5415 16.6903 25.5165C17.2397 25.4916 17.6456 25.221 17.9492 24.9448C18.2202 24.6983 18.5045 24.3569 18.8001 24.0021L18.8001 24.0021L18.8371 23.9577L27.8517 13.1402Z",
    fill: "#CDADFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.f4d77d1b2087e656ff1732461e09ca70.svg";
export { ForwardRef as ReactComponent };